export default "__VITE_ASSET__e03eab8b__"